import { Injectable } from "@angular/core";
import { APIService } from "./api.service";
//import { IAddImprovementInput, ICompleteEndOfMonthInput, ICreateEndOfMonthInput, ISaveEOMValuesInput, ISearchExportInput, ISearchInput, ITrainingReceivedInput } from "interfaces/API-interfaces.interfaces";

@Injectable({
  providedIn: "root",
})
export class APILoadingService {
  constructor(private _apiService: APIService) {}
  /* get */
  genericGet(url: string, body?: any) {
    return this._apiService.fetchData( baseApiUrl + url, body??true);
  };
  
  genericPost(url: string, body?: any) {
    return this._apiService.postData( baseApiUrl + url, body);
  };
  /* post */
  /* createEndOfMonth(createEndOfMonthInput: ICreateEndOfMonthInput) {
    return this._apiService.postData( baseApiUrl +"site/endOfMonth/createEndOfMonth",createEndOfMonthInput);
  };
  completeEndOfMonth(createEndOfMonthInput: ICompleteEndOfMonthInput) {
    return this._apiService.postData( baseApiUrl +"site/endOfMonth/completeEndOfMonth",createEndOfMonthInput);
  };
  saveEndOfMonthValues(saveEndOfMonthValuesInput: ISaveEOMValuesInput) {
    return this._apiService.postData( baseApiUrl +"site/endOfMonth/saveEndOfMonthValues",saveEndOfMonthValuesInput);
  };
  saveContinuousImprovement(saveContinuousImprovementInput: IAddImprovementInput) {
    return this._apiService.postData( baseApiUrl +"site/endOfMonth/saveContinuousImprovement",saveContinuousImprovementInput);
  };
  saveTrainingReceived(saveContinuousImprovementInput: ITrainingReceivedInput) {
    return this._apiService.postData( baseApiUrl +"site/endOfMonth/saveTrainingReceived",saveContinuousImprovementInput);
  };
  searchPost(searchInput: ISearchInput) {
    return this._apiService.postData( baseApiUrl +"site/endOfMonth/search",searchInput);
  };
  searcExporthPost(searchInput: ISearchExportInput) {
    return this._apiService.postExportData( baseApiUrl +"site/endOfMonth/searchExport",searchInput);
  };
 */
  /* delete */
 /*  genericDelete(url: string, id: string) {
    var params = {
      id: id
    };
    return this._apiService.deleteData( baseApiUrl +"site/endOfMonth/"+url,params);
  }; */
};